
import { timeRangeOptions } from "@/utils/options";
const templateTypeOptions = [
    {text: '日常邮件', id: 'dailyEmail'},
    {text: '节假日自动回复', id: 'holidayEmail'},
    {text: '差评关怀', id: 'badCommentEmail'},
    {text: '退货关怀', id: 'returnEmail'},
    {text: '退款关怀', id: 'refundEmail'},
    {text: '邀评信', id: 'inviteEmail'},
    {text: '自定义类型', id: 'customEmail'}
]
export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '模板类型',
    prop: 'templateType',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'templateType',
        propsData: {
            options: templateTypeOptions,
            placeholder: '模板类型'
        }
    }],
    defaultValue: ''
}, {
    label: '创建用户',
    labelWidth: '120px',
    prop: 'createUser',
    isFormItem: true,
    components: [{
        name: 'gj-creator-select',
        prop: 'createUser',
        propsData: {
            placeholder: '创建用户',
            collapseTags: true
        }
    }],
    defaultValue: []
}, {
    label: '更新用户',
    labelWidth: '120px',
    prop: 'updateUser',
    isFormItem: true,
    components: [{
        name: 'gj-creator-select',
        prop: 'updateUser',
        propsData: {
            placeholder: '更新用户',
            collapseTags: true
        }
    }],
    defaultValue: []
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: [
                {id: 'create', text: '创建时间'},
                {id: 'update', text: '更新时间'},
            ]
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'create'
}]
